module.exports = __webpack_public_path__ + "static/media/status5.d48e16f4.png";